import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
//@ts-ignore
import { Pannellum } from 'pannellum-react';
import { getSceneById } from "../sdk/scene";
//import Feelings_image from './Feelings_HKSTP.jpg';
import './Editor.css';

interface Style {
  id: string;
  name: string;
}

const styles: Style[] = [
    {
      id: '44',
      name: '1960s Ethereal Fantasy',
    },
    {
      id: '13',
      name: 'Advanced (no style)',
    },
    {
      id: '3',
      name: 'Anime',
    },
    {
      id: '43',
      name: 'Art Mix',
    },
    {
      id: '29',
      name: 'Cartoon',
    },
    {
      id: '31',
      name: 'Claymation',
    },
    {
      id: '35',
      name: 'Cyberpunk',
    },
    {
      id: '5',
      name: 'Digital Painting',
    },
    {
      id: '11',
      name: 'Dreamlike',
    },
    {
      id: '17',
      name: 'Dutch Masters',
    },
    {
      id: '42',
      name: 'Enchanted Painting',
    },
    {
      id: '40',
      name: 'Epic Digital Painting',
    },
    {
      id: '2',
      name: 'Fantasy',
    },
    {
      id: '33',
      name: 'Holographic',
    },
    {
      id: '18',
      name: 'Infrared Photography',
    },
    {
      id: '15',
      name: 'Interiors',
    },
    {
      id: '20',
      name: 'Kids CGI Animation',
    },
    {
      id: '36',
      name: 'Low Poly Triangles',
    },
    {
      id: '19',
      name: 'Low Poly Voxels',
    },
    {
      id: '77',
      name: 'M3 Above the Clouds',
    },
    {
      id: '121',
      name: 'M3 Above the Clouds (Featured)',
    },
    {
      id: '83',
      name: 'M3 Advanced (artistic)',
    },
    {
      id: '112',
      name: 'M3 Advanced (photo/render)',
    },
    {
      id: '74',
      name: 'M3 Americana Painting',
    },
    {
      id: '81',
      name: 'M3 Anime',
    },
    {
      id: '85',
      name: 'M3 Comic',
    },
    {
      id: '87',
      name: 'M3 Digital Painting',
    },
    {
      id: '120',
      name: 'M3 Digital Painting (Featured)',
    },
    {
      id: '75',
      name: 'M3 Dutch Masters',
    },
    {
      id: '95',
      name: 'M3 Elegant Maximalism',
    },
    {
      id: '122',
      name: 'M3 Elegant Maximalism (Featured)',
    },
    {
      id: '104',
      name: 'M3 Grunge Pop',
    },
    {
      id: '90',
      name: 'M3 Neo Tokyo',
    },
    {
      id: '89',
      name: 'M3 Open World',
    },
    {
      id: '67',
      name: 'M3 Photoreal',
    },
    {
      id: '119',
      name: 'M3 Photoreal (Featured)',
    },
    {
      id: '115',
      name: 'M3 Playground',
    },
    {
      id: '123',
      name: 'M3 Playground (Featured)',
    },
    {
      id: '80',
      name: 'M3 Psychedelic Illustration',
    },
    {
      id: '88',
      name: 'M3 Retro Fantasy',
    },
    {
      id: '118',
      name: 'M3 Retro Fantasy (Featured)',
    },
    {
      id: '93',
      name: 'M3 Scifi Concept Art',
    },
    {
      id: '114',
      name: 'M3 Sky Dome',
    },
    {
      id: '73',
      name: 'M3 Storybook',
    },
    {
      id: '68',
      name: 'M3 UHD Render',
    },
    {
      id: '46',
      name: 'Mandala',
    },
    {
      id: '25',
      name: 'Manga',
    },
    {
      id: '26',
      name: 'Modern Interiors',
    },
    {
      id: '7',
      name: 'Nebula',
    },
    {
      id: '37',
      name: 'Netrunner',
    },
    {
      id: '24',
      name: 'Pen & Ink',
    },
    {
      id: '48',
      name: 'Psychedelic Illustration',
    },
    {
      id: '41',
      name: 'Radiant Painting',
    },
    {
      id: '6',
      name: 'Radiant Realism',
    },
    {
      id: '9',
      name: 'Realism',
    },
    {
      id: '10',
      name: 'SciFi',
    },
    {
      id: '16',
      name: 'Sky Dome',
    },
    {
      id: '30',
      name: 'Storybook',
    },
    {
      id: '34',
      name: 'Stylized CGI Realism',
    },
    {
      id: '4',
      name: 'Surreal',
    },
    {
      id: '23',
      name: 'Technical Drawing',
    },
    {
      id: '32',
      name: 'Vibrant Watercolor',
    },
    {
      id: '22',
      name: 'Watercolor',
    },
    {
      id: '47',
      name: 'Whimsical World',
    }
];

function Editor() {

  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();

  const [showImage, setShowImage] = useState(true);
  const [showMusic, setShowMusic] = useState(true);
  const [imagePrompt, setImagePrompt] = useState("");
  const [musicPrompt, setMusicPrompt] = useState("");
  const [imageStyle, setImageStyle] = useState('2');
  const [musicStyle, setMusicStyle] = useState("");
  const [imageModel, setImageModel] = useState("Skybox");
  const [musicModel, setMusicModel] = useState("Suno");
  const [searchTerm, setSearchTerm] = useState("");

  const [sceneUrl, setSceneUrl] = useState("");

  const handleSubmission = () => {
    if (showImage) {
      console.log("Image Prompt:", imagePrompt, "Style:", imageStyle, "Model:", imageModel);
    }
    if (showMusic) {
      console.log("Music Prompt:", musicPrompt, "Style:", musicStyle, "Model:", musicModel);
    }
  };
  
  const handleSearch = () => {
    navigate(`/app/editor/${searchTerm}`);
  }

  useEffect(() => {
    if (id) {
      getSceneById({ params: { id: parseInt(id) } }).then(response => {
        if (response.error) {
          console.log(response.error);
        } else {
          setSceneUrl(response.image_url);
        }
      });
    }
  }, [id]);

  return (
    <div className="editor">
      <Pannellum
        width="100%"
        height="100vh"
        image={sceneUrl}
        pitch={10}
        yaw={300}
        hfov={110}
        autoLoad
        showZoomCtrl={false}
        showFullscreenCtrl={false}
        showControls={false}
      />
      <div className="floating-menu">
        <input 
          type="text" 
          value={searchTerm} 
          onChange={e => setSearchTerm(e.target.value)} 
          placeholder="Search by ID" 
        />
        <button onClick={handleSearch}>Search</button>
        <label>
          <input type="checkbox" checked={showImage} onChange={() => setShowImage(!showImage)} />
          Enable Image
        </label>
        {showImage && (
          <div>
            <input value={imagePrompt} onChange={e => setImagePrompt(e.target.value)} placeholder="Image Prompt" />
            <select value={imageStyle} onChange={e => setImageStyle(e.target.value)}>
              {
                styles.map(style => (
                  <option value={style.id}>{style.name}</option>
                ))
              }
            </select>
            <select value={imageModel} onChange={e => setImageModel(e.target.value)}>
              <option value="Skybox">Skybox</option>
            </select>
          </div>
        )}
        <label>
          <input type="checkbox" checked={showMusic} onChange={() => setShowMusic(!showMusic)} />
          Enable Music
        </label>
        {showMusic && (
          <div>
            <input value={musicPrompt} onChange={e => setMusicPrompt(e.target.value)} placeholder="Music Prompt" />
            <input value={musicStyle} onChange={e => setMusicStyle(e.target.value)} placeholder="Music Style" />
            <select value={musicModel} onChange={e => setMusicModel(e.target.value)}>
              <option value="Model A">Suno</option>
            </select>
          </div>
        )}
        <button onClick={handleSubmission}>Submit</button>
      </div>
    </div>
  );
}

export default Editor;
